import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Nullable } from '@/types/generic';
import { isNullish } from './predicates';

dayjs.extend(utc);

const ISO_DATE = 'YYYY-MM-DD';

export const firstDateForAge = (age: number | undefined, fixedDate: string | undefined = undefined) =>
  isNullish(age) ? undefined : dayjs(fixedDate).subtract(age, 'year').format(ISO_DATE);

export const lastDateForAge = (age: number | undefined, fixedDate: string | undefined = undefined) =>
  isNullish(age)
    ? undefined
    : dayjs(fixedDate)
        .subtract(age + 1, 'year')
        .subtract(1, 'day')
        .format(ISO_DATE);

export const formatYearInfo = (yearOfBirth?: number | null, age?: number | null) => {
  if (isNullish(yearOfBirth)) return null;
  return isNullish(age) ? `${yearOfBirth}` : `${yearOfBirth} (${age})`;
};

export const getIsDateBeforeOrEqualToToday = (date: Nullable<string>) => {
  if (!date) return false;

  const todayInUTC = dayjs().utc();
  return dayjs(date).isBefore(todayInUTC, 'day') || dayjs(date).isSame(todayInUTC, 'day');
};
